import { render, staticRenderFns } from "./ticketDetails.vue?vue&type=template&id=a5dbeffc&scoped=true&"
import script from "./ticketDetails.vue?vue&type=script&lang=js&"
export * from "./ticketDetails.vue?vue&type=script&lang=js&"
import style0 from "./ticketDetails.vue?vue&type=style&index=0&id=a5dbeffc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5dbeffc",
  null
  
)

export default component.exports